/**
 * Каталог гаджетов — глобальные тумблеры владельца.
 *
 * Отдельно от настроек панели: тут решается, какие типы вообще
 * существуют для всей компании, а не как выглядит одна конкретная
 * панель. Настройки людей при выключении не стираются — гаджет
 * перестаёт отдавать данные и возвращается как был.
 */
export function CatalogSettings({ items, onChange }) {
  const toggleType = (type) => {
    onChange(items.map((i) => (i.type === type ? { ...i, enabled: !i.enabled } : i)))
  }

  // null означает «всем ролям консоли», список — ограничение.
  // Отдельного состояния «никому» нет: для этого есть тумблер.
  const setTypeRoles = (type, roles) => {
    onChange(items.map((i) => (i.type === type ? { ...i, allowed_roles: roles } : i)))
  }

  return (
    <section className="catalog">
      <h3 className="catalog__title">Каталог гаджетов</h3>
      <p className="catalog__hint">
        Выключенный гаджет пропадает из галереи у всех и перестаёт отдавать
        данные. Настройки людей сохраняются — включите обратно, и панели
        вернутся как были. «Только админам» оставляет гаджет рабочим,
        но скрывает его от менеджеров.
      </p>

      <ul className="catalog__list">
        {items.map((item) => (
          <li key={item.type} className="catalog__row">
            <span className="catalog__name">
              <span className="catalog__label">{item.title}</span>
              <span className="catalog__desc">{item.description}</span>
            </span>

            <div className="catalog__controls">
              <select
                className="input input--compact"
                aria-label={`Кому доступен гаджет «${item.title}»`}
                disabled={!item.enabled}
                value={item.allowed_roles?.includes('admin') ? 'admin' : 'all'}
                onChange={(e) =>
                  setTypeRoles(item.type, e.target.value === 'admin' ? ['admin'] : null)
                }
              >
                <option value="all">Всем</option>
                <option value="admin">Только админам</option>
              </select>

              <button
                type="button"
                className={`switch ${item.enabled ? 'is-on' : ''}`}
                role="switch"
                aria-checked={item.enabled}
                aria-label={`${item.title}: ${item.enabled ? 'включён' : 'выключен'}`}
                onClick={() => toggleType(item.type)}
              >
                <span className="switch__knob" />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
